
import React from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import ActivePlayerAnalyticsTable from "../components/Analytics/ActivePlayerAnalyticsTable"
import RoundsReport from "../components/Analytics/RoundsReport"

export default function Analytics() {
    document.title = 'Analytics - TMH Admin';

    return (
        <>
            <div className="content">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>
                                <h3 className="title">ANALYTICS</h3>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md="12">
                                        <ActivePlayerAnalyticsTable />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        <RoundsReport />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}
